export const DISALLOWED_CHARACTERS = /[^a-zA-Z\d\s\u00C0-\u00FF]/g;
